/**
 * The JSX runtime of this app: React's own, with the text of each HTML element put in
 * the active language on the way in (see `render.ts`, reached through `hook.ts`). The
 * build names this module as the place JSX comes from (`jsxImportSource`), so every
 * screen goes through it.
 */
import type { ElementType, Key, ReactElement } from 'react';
import * as react from 'react/jsx-runtime';
import { shown } from './hook';

export type { JSX } from 'react/jsx-runtime';
export const Fragment = react.Fragment;

export function jsx(type: ElementType, props: unknown, key?: Key): ReactElement {
  return react.jsx(type, shown(type, props) as object, key);
}

export function jsxs(type: ElementType, props: unknown, key?: Key): ReactElement {
  return react.jsxs(type, shown(type, props) as object, key);
}
